import { render, staticRenderFns } from "./UploadImagePreview.vue?vue&type=template&id=1d12a736&scoped=true&"
import script from "./UploadImagePreview.vue?vue&type=script&lang=js&"
export * from "./UploadImagePreview.vue?vue&type=script&lang=js&"
import style0 from "./UploadImagePreview.vue?vue&type=style&index=0&id=1d12a736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12a736",
  null
  
)

export default component.exports